export const _LOAD_MODEL_COMPANY_ = 'Load:Company';
export const _LOAD_MODEL_SETTING_ = 'Load:Setting';

export const COMPANY = {
  city: '',
  cnpj: '',
  site: '',
  state: '',
  email: '',
  number: '',
  address: '',
  zipcode: '',
  district: '',
  whatsapp1: '',
  whatsapp2: '',
  instagram: '',
  name: '',
  bgColor: '#ffffff',
  fontColor: '#ffffff',
  fontColor2: '#ffffff',
  titleColor: '#ffffff',
};

export const SETTINGS = {
  logo: null,
  resellerNational: null,
  regional: {
    nordeste: false,
    sudeste: false,
    norteSul: false,
  }
};

export const OPTION = { id: null, slug: null, name: '' };

export const PERMISSION = {
  module_id: null,
  name: null,
  description: null,
  slug: null,
  active: true,
};
